export default __webpack_public_path__ + "static/media/tamara couture.86747c85.jpeg";